import type { FaireProductEntity } from "../../entity_types/product";

export const p_ew3sf3zuqh: FaireProductEntity = {
  token: "p_ew3sf3zuqh",
  type: "product",
  name: "Garden Herb Sea Salt",
  brandToken: "b_xhgxgkda5f",
  brandName: "Jar Masala",
  imageUrl:
    "https://cdn.faire.com/fastly/fdca7c0ceb5b90a7f5556cf1b27d4f682ac4878506f43e723704263f46ef224d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ccc01a08de7ed3e76eb5ea7a6145e83bbdeda7b98b9536877369ad168cf18e66.jpeg",
    "https://cdn.faire.com/fastly/622842df64b822b1a599a204b755869cc7dfb35201e1c56d00eb39e210bc8862.jpeg",
    "https://cdn.faire.com/fastly/7f89f45e0c318494ec979f53ed575caebfa7049d635d6c6242faff90a9e2fa2f.jpeg",
    "https://cdn.faire.com/fastly/974d71b489fa59df9847c83ad2bc4d64e21b6f670aba94fec9b4468d4c7ee6e7.jpeg",
  ],
  priceDollars: 7.62,
  description:
    "Our Italian-inspired Garden Herb Sea Salt is a premium, aromatic blend of coarse sea salt infused with dried herbs and savory garlic undertones. Designed for finishing or roasting, this versatile, savory seasoning transforms roasted meats, vegetables, salads, soups, and eggs into gourmet dishes. \n\nHow to Use Tips:\nPerfect as a finishing salt for all sorts of dishes, roasted veggies, tofu, eggs, salad and snack foods like popcorn.\nIdeal as a rub for chicken/poultry, seasoning for roasted vegetables, in soups, salads, and on fresh bread with butter.\n\n4oz. | $5.50\nAromatic spices are roasted and blended in small batches to ensure optimal flavor and freshness.\nPremium, great quality ingredients blended with flavors in mind. \nGourmet blend by a women-owned artisanal spice company in Snellville, GA. \nHandcrafted in the USA from imported and local ingredients.\n\n*Wooden Spice Spoon included w/4oz. Jar",
  tags: [],
  msrpDollars: 15.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:56.963Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
